import type { LoadingHookUser } from '@local/login/dist/apiClients/types';
import { COMBINED_TOKEN_KEY } from '@local/login/dist/constants';
import type { DecodedToken } from '@local/login/dist/store/sessionStorageHelpers/entitlementsHelper/entitlementsHelper';
import { decodeToken } from 'react-jwt';

type AccessTokenType = {
    id_token: string;
};

export const getCurrentUserDetails = (): LoadingHookUser | undefined => {
    const accessToken = JSON.parse(
        localStorage.getItem(COMBINED_TOKEN_KEY) || '{}',
    ) as AccessTokenType;
    const decodedToken: DecodedToken | null = decodeToken(accessToken.id_token);

    if (decodedToken) {
        const userDetails = {
            data: {
                given_name: decodedToken?.given_name,
                family_name: decodedToken?.family_name,
                email: decodedToken?.email,
                sub: decodedToken?.sub,
            },
            isLoading: false,
            isFetching: false,
            isError: false,
            error: null,
        };
        return userDetails;
    }

    return undefined;
};
